import { ReactNode } from "react";
import { Info } from "lucide-react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "shared/ui";

interface AccountDispositionStatusPillPropsI extends PropsWithClassNameI {
  style?: string;
  label: string;
  tooltip?: ReactNode;
}

export const AccountDispositionStatusSmallPill = ({
  className,
  style,
  label,
  tooltip,
}: AccountDispositionStatusPillPropsI) => {
  if (!label) {
    return null;
  }

  const pillContent = (
    <section className="flex items-center gap-1">
      <div
        className={clsxMerge(
          "w-max min-w-[84px] px-2 py-0",
          "text-center text-white typography-header-8-semibold",
          "gap-2 rounded flex-center",
          style,
          className
        )}
      >
        {label}

        {tooltip && <Info size={16} />}
      </div>
    </section>
  );

  return tooltip ? (
    <Tooltip placement="bottom">
      <TooltipTrigger>{pillContent}</TooltipTrigger>
      <TooltipContent className="z-50 max-w-[300px]">{tooltip}</TooltipContent>
    </Tooltip>
  ) : (
    pillContent
  );
};
